/*
  Round 9: "Share Wishlist as PDF" -- self-contained, only runs on the Wishlist page.
  Reads the already-rendered wishlist cards straight out of the DOM (built by
  assets/wishlist.js) and lays them out into a downloadable PDF via jsPDF, which is
  loaded from cdnjs only on this page (see sections/page-wishlist.liquid). Does not
  touch cart, wishlist, or product-card logic anywhere.
*/
(function () {
  function normalizeImageToJPEG(url) {
    return fetch(url, { mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('image fetch failed')
        return res.blob()
      })
      .then(function (blob) { return createImageBitmap(blob) })
      .then(function (bitmap) {
        var canvas = document.createElement('canvas')
        var maxSide = 500
        var scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height))
        canvas.width = Math.max(1, Math.round(bitmap.width * scale))
        canvas.height = Math.max(1, Math.round(bitmap.height * scale))
        var ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
        return { dataUrl: canvas.toDataURL('image/jpeg', 0.85), width: canvas.width, height: canvas.height }
      })
      .catch(function () { return null })
  }

  function collectWishlistItems() {
    var cards = document.querySelectorAll('.m-wishlist-page-content__wrapper .m-wishlist-card')
    return Array.from(cards).map(function (card) {
      var img = card.querySelector('.ic__media img')
      var titleLink = card.querySelector('.ic__t a')
      var priceEl = card.querySelector('.ic__p b')
      var compareEl = card.querySelector('.ic__p s')
      var saveEl = card.querySelector('.ic__save')
      return {
        imageUrl: img ? (img.currentSrc || img.src) : null,
        title: titleLink ? titleLink.textContent.trim() : 'Product',
        url: titleLink ? titleLink.href : window.location.origin,
        price: priceEl ? priceEl.textContent.trim() : '',
        comparePrice: compareEl ? compareEl.textContent.trim() : '',
        saveText: saveEl ? saveEl.textContent.trim() : ''
      }
    })
  }

  function buildPdf(items, images) {
    var jsPDF = window.jspdf.jsPDF
    var doc = new jsPDF({ unit: 'pt', format: 'a4' })
    var pageWidth = doc.internal.pageSize.getWidth()
    var pageHeight = doc.internal.pageSize.getHeight()
    var margin = 40
    var rowHeight = 92
    var imgSize = 72
    var y = margin

    function drawHeader() {
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(20)
      doc.setTextColor(47, 74, 59) // Ivory & Ink primary green
      doc.text('My Inkarto Wishlist', margin, y)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(10)
      doc.setTextColor(120, 120, 120)
      var dateStr = new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })
      doc.text(dateStr + '  ·  ' + items.length + ' item' + (items.length === 1 ? '' : 's') + '  ·  inkarto.com', margin, y + 16)
      y += 40
      doc.setDrawColor(230, 224, 210)
      doc.line(margin, y, pageWidth - margin, y)
      y += 20
    }

    drawHeader()

    items.forEach(function (item, i) {
      if (y + rowHeight > pageHeight - margin) {
        doc.addPage()
        y = margin
        drawHeader()
      }

      var textX = margin + imgSize + 16
      var textWidth = pageWidth - margin - textX

      if (images[i]) {
        try {
          var ratio = images[i].width / images[i].height
          var w = imgSize
          var h = imgSize
          if (ratio > 1) { h = imgSize / ratio } else { w = imgSize * ratio }
          var ix = margin + (imgSize - w) / 2
          var iy = y + (imgSize - h) / 2
          doc.setFillColor(248, 244, 236)
          doc.roundedRect(margin, y, imgSize, imgSize, 6, 6, 'F')
          doc.addImage(images[i].dataUrl, 'JPEG', ix, iy, w, h)
        } catch (e) { /* skip broken image, text still renders */ }
      } else {
        doc.setFillColor(248, 244, 236)
        doc.roundedRect(margin, y, imgSize, imgSize, 6, 6, 'F')
      }

      doc.setFont('helvetica', 'bold')
      doc.setFontSize(12)
      doc.setTextColor(33, 31, 27)
      var titleLines = doc.splitTextToSize(item.title, textWidth)
      doc.text(titleLines.slice(0, 2), textX, y + 16)

      var priceY = y + 16 + Math.min(titleLines.length, 2) * 15 + 6
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(12)
      doc.setTextColor(47, 74, 59)
      doc.text(item.price, textX, priceY)

      if (item.comparePrice) {
        var priceW = doc.getTextWidth(item.price)
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(10)
        doc.setTextColor(150, 150, 150)
        doc.text(item.comparePrice, textX + priceW + 8, priceY)
      }

      doc.setFont('helvetica', 'normal')
      doc.setFontSize(9)
      doc.setTextColor(168, 92, 50)
      doc.textWithLink(item.url.replace(/^https?:\/\//, ''), textX, priceY + 16, { url: item.url })

      y += rowHeight
      doc.setDrawColor(240, 236, 226)
      doc.line(margin, y - 14, pageWidth - margin, y - 14)
    })

    var pageCount = doc.internal.getNumberOfPages()
    for (var p = 1; p <= pageCount; p++) {
      doc.setPage(p)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(9)
      doc.setTextColor(160, 160, 160)
      doc.text('Page ' + p + ' of ' + pageCount, pageWidth - margin, pageHeight - 20, { align: 'right' })
    }

    doc.save('inkarto-wishlist.pdf')
  }

  function init() {
    var btn = document.querySelector('.m-wishlist-share-pdf')
    if (!btn) return
    var defaultLabel = btn.textContent.trim()

    btn.addEventListener('click', function () {
      var items = collectWishlistItems()
      if (!items.length) return

      btn.disabled = true
      btn.textContent = 'Preparing PDF…'

      Promise.all(items.map(function (item) {
        return item.imageUrl ? normalizeImageToJPEG(item.imageUrl) : Promise.resolve(null)
      }))
        .then(function (images) {
          buildPdf(items, images)
        })
        .catch(function (err) {
          console.error('Wishlist PDF generation failed:', err)
        })
        .finally(function () {
          btn.disabled = false
          btn.textContent = defaultLabel
        })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
